import { CreditCardIcon } from "lucide-react";
import PaymentTable from "../tables/payment-table";
import NoPreviewCard from "../card/no-preview-card";
import { PatientPaymentHistory } from "../../api/types";

const PaymentHistoryDetails = ({ paymentHistoryData }: { paymentHistoryData: PatientPaymentHistory | null }) => {

  return (
    <div className="w-full rounded-lg border shadow bg-white">
      <div>
        {paymentHistoryData && paymentHistoryData.payments?.length > 0 ? (
          <>
            <div className="p-4 border-b">
              <h2 className="text-lg font-medium">Payment History</h2>
            </div>
            <PaymentTable data={paymentHistoryData.payments} />
          </>
        ) : (
          <NoPreviewCard
            Icon={CreditCardIcon}
            title="Payment History"
            description="No payment history found"
            cardTitle="Payment History"
          />
        )}
      </div>
    </div>
  )
}

export default PaymentHistoryDetails;